var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosition2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.97522C0 4.68933 0 3.40131 0 2.11542H6.10796V0H14.3103V2.12609H20.3942C20.3942 3.37999 20.4134 4.61256 20.3822 5.84514C20.3727 6.22046 20.2791 6.61283 20.1327 6.96683C19.4562 8.60884 17.8489 9.58552 15.8816 9.58978C14.9196 9.58978 13.9552 9.58978 12.9932 9.58978C12.9284 9.58978 12.8661 9.58552 12.7797 9.58125V8.53633H7.60256V9.57485C6.40544 9.57485 5.22511 9.64309 4.05918 9.55993C2.2551 9.42985 0.993203 8.55766 0.307077 7.06492C0.15114 6.72159 0.10076 6.33988 0 5.97522ZM7.30268 1.05984V2.10476H13.094V1.05984H7.30268Z",
    fill: "#EE4B22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9994C0 13.579 0 11.1587 0 8.73828C0.146341 8.88329 0.285486 9.0347 0.441423 9.17118C1.57617 10.1606 2.94362 10.649 4.53179 10.6511C5.48181 10.6511 6.43183 10.6511 7.38185 10.6511H7.61695V11.7003H12.8013V10.6511H13.0316C13.9888 10.6511 14.9436 10.6554 15.9008 10.6511C17.3882 10.6447 18.6957 10.2118 19.7945 9.30979C20.0008 9.14132 20.2095 8.97499 20.3918 8.82785V15.9994C20.2959 15.9994 20.2095 15.9994 20.1256 15.9994C13.4178 15.9994 6.71012 15.9994 0.00239904 15.9994H0Z",
    fill: "#EE4B22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80859 10.6411V9.60254H11.5795V10.6411H8.80859Z",
    fill: "#EE4B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition2);
export default __webpack_public_path__ + "static/media/Position2.7f89d5017bc4057b10a3932f226cae2c.svg";
export { ForwardRef as ReactComponent };